import { passwordMinLength } from './integrationConfig'

export interface AccountFormValues {
  first_name: string
  last_name: string
  email: string
  password: string
  password_confirmation: string
  terms_accepted: boolean
}

export type AccountFormErrors = Partial<Record<keyof AccountFormValues, string>>

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

/** Client-side validation only — the Edge Function must re-validate everything. */
export function validateAccountForm(values: AccountFormValues): AccountFormErrors {
  const errors: AccountFormErrors = {}

  if (!values.first_name.trim()) errors.first_name = 'Enter your first name.'
  if (!values.last_name.trim()) errors.last_name = 'Enter your last name.'

  if (!values.email.trim()) errors.email = 'Enter your email address.'
  else if (!EMAIL_PATTERN.test(values.email.trim())) errors.email = 'Enter a valid email address, like name@example.com.'

  if (!values.password) errors.password = 'Create a password.'
  else if (values.password.length < passwordMinLength)
    errors.password = `Use at least ${passwordMinLength} characters.`

  if (!values.password_confirmation) errors.password_confirmation = 'Confirm your password.'
  else if (values.password_confirmation !== values.password)
    errors.password_confirmation = 'Passwords don’t match.'

  if (!values.terms_accepted)
    errors.terms_accepted = 'Please agree to the Terms of Service and Privacy Policy to continue.'

  return errors
}
